import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";


import setupInterceptors from './services/setupInterceptors';
import { FontAwesomeIcon } from './plugins/font-awesome';
import Pagination from 'v-pagination-3';
import VueApexCharts from 'vue3-apexcharts'; // Importe o pacote vue3-apexcharts
import draggable from 'vuedraggable';

import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css'
import "@/assets/styles/dealdesk.css";
import "bootstrap";


setupInterceptors(store);


createApp(App)
  .use(router)
  .use(store)
  .use(Pagination)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(VueApexCharts)
  .use(draggable) // Registre o pacote vue3-apexcharts
 
  .mount("#app");